module.exports = __webpack_public_path__ + "img/ARIA-full.c1ce7eba.svg";